import { NgModule } from '@angular/core';

import { CmpsTeamsCallCallDialogModule } from './call-dialog';
import { CmpsTeamsCallCallHudModule } from './call-hud';
import {
    CallStatusService,
    ChatStatusService,
    TaskStatusService,
    TranscriptService,
} from './core';
import { SocketService } from './core/socket.service';

@NgModule({
    imports: [CmpsTeamsCallCallDialogModule, CmpsTeamsCallCallHudModule],
    providers: [
        CallStatusService,
        ChatStatusService,
        SocketService,
        TaskStatusService,
        TranscriptService,
    ],
})
export class CmpsTeamsCallModule {}
